import React from "react";
import HandelaarInfo from "./HandelaarInfo";

import { Button, Grid } from "@material-ui/core";

function parseLocation(lat, lng, zoom) {
  return {
    lat: lat + Math.random() * 0.00001,
    lng: lng + Math.random() * 0.00001,
    zoom: zoom,
  };
}

export const CardList = ({
  filteredIndices,
  handelaars,
  modalHandelaar,
  setModalHandelaar,
  setZoomLocation,
  setSearchOpen,
}) => {
  return (
    <div>
      <Grid container style={{ paddingTop: "20px" }}>
        {handelaars.map((h, i) => (
          <Grid
            item
            xs={12}
            key={i}
            style={{
              textAlign: "center",
              paddingBottom: "20px",
              display: filteredIndices.includes(i) ? "none" : "inline",
            }}
          >
            {card(setModalHandelaar, h, i)}
          </Grid>
        ))}
      </Grid>
      <HandelaarInfo
        open={modalHandelaar !== -1}
        close={() => {
          setModalHandelaar(-1);
        }}
        changeZoomLocation={(lat, lng, zoom) => {
          setModalHandelaar(-1);
          setSearchOpen(false);
          setZoomLocation(parseLocation(lat, lng, zoom));
        }}
        handelaar={handelaars[modalHandelaar]}
      />
    </div>
  );
};

const card = (setModalHandelaar, h, i) => {
  return (
    <Button
      variant="outlined"
      onClick={() => setModalHandelaar(i)}
      style={{ maxWidth: "400px", width: "100%" }}
    >
      <Grid item style={{ height: "75px" }}>
        <h2>
          <b>{h.title}</b>
        </h2>
        <p style={{ paddingTop: "5px" }}> {h.place}</p>
      </Grid>
    </Button>
  );
};
